import { render } from "@/web/pages/doctores/Doctores.html?vue&type=template&id=112b977c&ts=true"
import script from "@/web/ts/controllers/doctor/doctores.ts?vue&type=script&lang=ts"
export * from "@/web/ts/controllers/doctor/doctores.ts?vue&type=script&lang=ts"

import "@/web/css/custom.css?vue&type=style&index=0&lang=css"

import exportComponent from "/Users/femers/git/adminSanatorio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__